import { connect } from "react-redux";
import { useState } from "react";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import { getCookie, setCookie } from "utils/cookies";
import { Main } from "layouts";
import { PanelLoader } from "components";
import { ReactComponent as InfoIcon } from "icons/info.svg";
import { client_v2 } from "utils/api";

const enabled_emails = ["sylwiaryba@tradecron.co"];

const TimeRecordValidator = ({ current_user, children }) => {
  const time_record_date = getCookie("wms_time_record_date");
  const wms_open_past_day_time_records_confirmed = getCookie(
    "wms_open_past_day_time_records_confirmed",
  );

  const is_open_past_day_time_records_confirmed =
    wms_open_past_day_time_records_confirmed === "true";

  const [dates_to_confirm, setDatesToConfirm] = useState([]);
  if (
    current_user.role === "admin" ||
    enabled_emails.includes(current_user.email)
  ) {
    return children;
  }

  const is_today_time_record = time_record_date
    ? moment(time_record_date).isSame(moment(), "day")
    : false;

  const { isFetching: is_loading_active_time_record } = useQuery(
    ["wms_time_record_date"],
    () => client_v2.get("/users/check_for_active_time_record"),
    {
      enabled: !is_today_time_record,
      select: (res) => res.data,
      retry: false,
      onSuccess: async ({ date }) => {
        setCookie(
          "wms_time_record_date",
          date,
          moment(date).endOf("day").toDate(),
        );
        window.location.reload();
      },
    },
  );

  const { isFetching: is_loading_open_past_day_time_records } = useQuery(
    ["wms_open_past_day_time_records_date"],
    () => client_v2.get("/users/check_for_open_past_day_time_records"),
    {
      enabled: !is_open_past_day_time_records_confirmed,
      select: (res) => res.data,
      retry: false,
      onSuccess: async ({ dates }) => {
        setDatesToConfirm(dates);
        if (!dates.length) {
          setCookie(
            "wms_open_past_day_time_records_confirmed",
            "true",
            moment().endOf("day").toDate(),
          );
          window.location.reload();
        } else {
          setDatesToConfirm(dates);
        }
      },
    },
  );

  const is_loading =
    is_loading_active_time_record || is_loading_open_past_day_time_records;

  if (is_today_time_record && is_open_past_day_time_records_confirmed) {
    return children;
  }

  return (
    <Main>
      {is_loading ? (
        <PanelLoader />
      ) : (
        <div className="dashboard">
          <header className="dashboard__header dashboard__header--edit">
            <div className="icon__container">
              <InfoIcon />
            </div>
            <h2 className="dashboard__title heading">Uwaga!</h2>
          </header>
          <div className="dashboard__form">
            {dates_to_confirm.length > 0 ? (
              <>
                <p>Masz niezakończone czasy pracy dla dni:</p>
                <ul>
                  {dates_to_confirm.map((date) => (
                    <li key={date} className="text-danger">
                      {moment(date).format("DD.MM.YYYY")}
                    </li>
                  ))}
                </ul>
                <p>
                  Aby kontunuować dodaj czas zakończenia pracy w aplikacji{" "}
                  <a
                    className="link"
                    href="https://board.tradesk.pl"
                    target="_blank"
                  >
                    <strong>Board</strong>
                  </a>
                  .
                </p>
              </>
            ) : (
              <>
                <p>Nie masz zarejestrowanego czasu rozpoczęcia pracy!</p>
                <p>
                  Aby kontunuować dodaj czas pracy w aplikacji{" "}
                  <a
                    className="link"
                    href="https://board.tradesk.pl"
                    target="_blank"
                  >
                    <strong>Board</strong>
                  </a>
                  .
                </p>
              </>
            )}
          </div>
        </div>
      )}
    </Main>
  );
};

export default connect(({ current_user }) => ({
  current_user,
}))(TimeRecordValidator);
